import axios from 'axios'

export default {
    getAll: () => axios.get(`/product`),
    getIikoProducts: () => axios.get(`/product/iiko_products`),
    getIikoCategoryProducts: () => axios.get(`/product/iiko_category_products`),
    syncIikoProducts: () => axios.get(`/product/iiko_products_sync`),
    getById: productId => axios.get(`/product/${productId}`),
    create: formData => axios.post(`/product/create`, formData),
    edit: formData => axios.put(`/product/edit`, formData),
    changeStatus: formData => axios.patch(`/product/toggle_status`, formData),
    delete: productId => axios.delete(`/product/delete/${productId}`),
    deleteImg: (productId, personalKey) => axios.delete(`/product/img/delete/${productId}/${personalKey}`)
}
